import { ClassificationContent } from '@shared/components/molecules/class-details/models/class-details.model';
import { IResponse } from '@shared/models/base/http-response.model';

export const CLASSIFICATION_CONTENT: ClassificationContent = {
  ruleText: 'Item 420',
  title: 'CLASSIFICATION OF ARTICLES-GENERAL',
  content: `
  <p><strong>Sec. 1.</strong> Numbers 50 to 500, specified in the 'CLASS'
    column in the Articles section of this Classification, and as amended, are the classes assigned to the articles
    described in connection therewith and refer to rates established by carriers for the same respective classes in
    tariffs governed by this Classification. Classes 77.5 and 92.5 refer also to rates for classes
    77<sup>1</sup>/<sub>2</sub> and 92<sup>1</sup>/<sub>2</sub>, respectively, in carriers' tariffs governed by this
    Classification.</p>
  <p class="text-rule-10">The progression of classes in this Classification is from 50 (lowest) to 500 (highest).</p>
  <p><strong>Sec. 2.</strong> Not currently used.</p>
  <p><strong>Sec. 3.</strong> When '0' is shown in the 'CLASS' column, it
    means that the unique nature of the article named prevents the assignment in this Classification of a class based
    upon the recognized transportation characteristics. Refer to the terms, conditions, rules and other provisions of
    individual carriers pertaining to the article being shipped.</p>
  <p><strong>Sec. 4.</strong> Where a carrier's rate tariff governed by this
    Classification does not provide a rate for a class shown in this Classification and no other provision is made in
    that carrier's tariff as to the application of such class, apply the rate for the next higher class for which rates
    are provided.</p>
  <p><strong>Sec. 5.</strong> In determining the applicable classification
    provision, a specific description takes precedence over a more general description provided the article or material
    being classified is actually embraced within the terms of the specific description, including any generic heading,
    subheading(s) and Note reference(s).</p>
 `,
};

export const CLASSIFICATION_CONTENT_RESPONSE: IResponse<ClassificationContent> = {
  success: true,
  code: 200,
  data: CLASSIFICATION_CONTENT,
};
